<template>
  <div :class="[invalid ? 'custom-field--invalid' : 'custom-field--valid',brandClass]">
    <label class="checkbox__box">
      <input
        class="custom-input-checkbox " 
        :class="[brandClass, {'invalid':invalid}]" 
        type="checkbox" 
        :name="paramName" 
        :id="id" 
        :aria-labelledby="labelledBy" 
        :disabled="disabled"
        :checked="modelValue"
        @change="onInput"
      />
      <span 
        class="checkbox__mark" 
        tabindex="0" 
        :aria-labelledby="labelledBy" 
        role="button" 
        @keydown="ariaClick" 
        :class="[brandClass, {'invalid':invalid}]">
      </span>
      <span :id="labelledBy">
        <slot name="labelcontent"></slot>
      </span>
    </label>
    <slot name="checkboxerror"></slot>
  </div>
</template>

<script>
import oneUtils from "../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";
import {defineComponent} from 'vue';
export default defineComponent({
  mixins:[oneUtils.accessibilityMixin],
  emits: ['update:modelValue'],
  name: 'OneCheckbox',
  props: {
    brandClass:{
      type: String,
      required: false,
      default: '__b'
    },
    labelledBy:{
      type: String,
      required: false,
      default: ''
    },
    id: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    required: {
      type: Boolean,
      required: true,
      default: false
    },
    modelValue: null,
    form:{
      type: Object,
      required: false
    },
    errors:null,
    paramName:{
      type: String,
      required: false
    }
  },
  computed: {
    valid(){
      return !this.required || !this.form[this.paramName].$invalid
    },
    invalid(){
      return this.required && this.form[this.paramName].$dirty && !this.modelValue;
    }
  },
  methods: {
    onInput(event) {
      // Can add validation here
      this.$emit('update:modelValue', event.target.checked);
    }
  },
});
</script>

<style lang="scss" scoped>
@import './styles/_variables.scss';

.custom-field--valid, .custom-field--invalid{
  width: auto;
}
.checkbox__box {
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
  cursor: pointer;
  font-size: 20px;
  padding: 8px;
  margin: -8px;
}

.checkbox__mark {
  position: absolute;
  top: 8px;
  left: 8px;
  margin: 0;
  margin-right: 10px;
  display: grid;
  place-content: center;
  border-radius: 0px;
  min-width: 16px;
  margin-top: 0px;
  height: 24px;
  width: 24px;
  border: 2px solid $grey3;

  &.__b {
    border: 2px solid #8E8E8E;
  }
 
  &.__m{
    border: 2px solid black;
    border-radius: 0;
    &.__d{
      border-color: white;
    }
  }
  &.__t{
    margin-top: 1px;
    border-radius: 0px;
    border: 1px solid $toyotared;
    height: 22px;
    width: 22px;
    margin-right: 5px;
  }
  &.__motorrad{
    border: 2px solid $black;
    background: transparent;
    &.__d{
      border-color: white;
    }

    &:hover{
      border-color: $motorradblue;
    }
  }
  &.__alphabet{
    height: 20px;
    width: 20px;
    border: 1px solid $alphabetblue;
    &:hover{
      border: 2px solid $alphabetfreshbluelight;
    }
  }
  &.invalid{
    border: 2px solid $red;
    background: $errorbg;
    &.__motorrad{
      border: 2px solid $black;
      background: transparent;
      &.__d{
        border-color: white;
      }
    }
    &.__alphabet{
      background: white;
      &:hover{
        border: 2px solid $red;
        background: white;
      }
    }
  }
}

.checkbox__box input:checked + .checkbox__mark {
  background: $grey4;
  border-color: $grey4;
  &.__m{
    background: black;
    border-color: black;
      &.__d{
        border-color: white;
      }
  }
  &.__motorrad{
    background: black;
    border-color: black;
    &.__d{
      border-color: white;
      background: transparent;
    }

    &:hover{
      background: $motorradblue;
      border-color: $motorradblue;
    }
  }
  &.__t{
    background: $toyotared;
    border-color: $toyotared;
  }
  &.__alphabet{
    border-color: $alphabetfreshblue;
    background-color: transparent;
    &:hover{
      border: 1px solid $alphabetfreshbluelight;
    }
  }
}

.checkbox__mark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox__box input:checked + .checkbox__mark:after {
  display: block;
}

.checkbox__box .checkbox__mark:after {
  width: 6px;
  height: 11px;
  top: 4px;
  left: 7px;
  border: solid #eee;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.checkbox__box .checkbox__mark.__m:after{
  width: 8px;
  height: 13px;
  top: 1px;
  left: 6px;
  border: 1px solid #fff;
  border-top: 0;
  border-left: 0;
}
.checkbox__box .checkbox__mark.__motorrad:after{
  width: 7px;
  height: 11px;
  top: 3px;
  left: 6px;
  border: 3px solid #fff;
  border-top: 0;
  border-left: 0;
}

.checkbox__box .checkbox__mark.__alphabet:after{
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  border: 5px solid $alphabetfreshblue;
  -webkit-transform: rotate(0);
  -ms-transform: rotate(0);
  transform: rotate(0);
}
.checkbox__box .checkbox__mark.__alphabet:hover:after{
  border: 5px solid $alphabetfreshbluelight;
}
input[type="checkbox"] {
  visibility: hidden;
}
</style>


